import React from "react";
import {
  Grid,
  TableBody,
  TableRow,
  CardContent,
  Divider,
  Card,
} from "@material-ui/core";
import TableBodyCell from "components/table/TableBodyCell";
import { BootstrapBadge } from "components/ui/BootstrapBadge";
import { readableFormatDate } from "shared/utils";
import { CustomTableWrapper } from "shared/components/CustomTableWrapper";

const verified=["Not Verified","Verified","Cancelled"]

export const CashDetails = ({ data }) => {
  return (
    <>
      <Card>
        <CardContent className="card-content_head">
          <Grid container alignItems="center">
            <Grid item xs={6}>
              Cash Details
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardContent>
          <CustomTableWrapper>
            <Grid item xs={6}>
              <table className="w-full">
                <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Cash Collected Reference No.</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {data["cash_collected_reference_number"]}
                  </TableBodyCell>
                  </TableRow>
                </TableBody>
                <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Comment</TableBodyCell>
                  <TableBodyCell className="common_table_content">{data["comment"]}</TableBodyCell>
                  </TableRow>
                </TableBody>
                <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Cash Collected By Subuser</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {data["cash_collected_subuser_ref_no"]}
                  </TableBodyCell>
                  </TableRow>
                </TableBody>
                <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Cash Collected By Subuser Date</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {readableFormatDate(
                      data["cash_collected_subuser_id_datetime"]
                    )}
                  </TableBodyCell>
                  </TableRow>
                </TableBody>
               
              </table>
            </Grid>

            <Grid item xs={6}>
              <table className="w-full">
                <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Cash Collection Source</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {data["cash_collection_source"]}
                  </TableBodyCell>
                  </TableRow>
                </TableBody>
                <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Status</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    <BootstrapBadge
                      backgroundColor="#0ABB87"
                      text={data["cash_status"]}
                    />
                  </TableBodyCell>
                  </TableRow>
                </TableBody>
                 <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Bank Deposit Reference No.</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {data["bank_deposit_reference_number"]}
                  </TableBodyCell>
                  </TableRow>
                </TableBody>
                <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Created Date</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    {readableFormatDate(data["created_at"])}
                  </TableBodyCell>
                  </TableRow>
                </TableBody>
              </table>
            </Grid>
          </CustomTableWrapper>
        </CardContent>
      </Card>
      {data["deposit"] ? (
        <Card>
          <CardContent className="card-content_head">
            <Grid container alignItems="center">
              <Grid item xs={2}>
              Deposit Details
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <CardContent>
            <CustomTableWrapper>
              <Grid item xs={6}>
                <table className="w-full">
                  <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">Bank Deposite Reference No.</TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      {data["deposit"]["bank_deposit_reference_number"]}
                    </TableBodyCell>
                    </TableRow>
                  </TableBody>
                  <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">Bank Deposite Slip No</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data["deposit"]["bank_deposit_slip_number"]}</TableBodyCell>
                    </TableRow>
                  </TableBody>
                  <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">Amount</TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      {data["deposit"]["amount"]}
                    </TableBodyCell>
                    </TableRow>
                  </TableBody>
                  <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">
                     Deposit Time
                    </TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      {readableFormatDate(
                        data["deposit"]["deposit_datetime"]
                      )}
                    </TableBodyCell>
                    </TableRow>
                  </TableBody>
                
                </table>
              </Grid>

              <Grid item xs={6}>
                <table className="w-full">
                <TableBody>
                <TableRow>
                    <TableBodyCell className="common_table_title">Is Verified</TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      {data["deposit"]["is_verified"]!==null?verified[data["deposit"]["is_verified"]]:"Not Checked"}
                    </TableBodyCell>
                    </TableRow>
                  </TableBody>
                  <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">Cash Deposit Reference No</TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      {data["deposit"]["cash_deposit_reference_number"]}
                    </TableBodyCell>
                    </TableRow>
                  </TableBody>
                  {/* <TableBody>
                    <TableBodyCell>Status</TableBodyCell>
                    <TableBodyCell>
                      <BootstrapBadge
                        backgroundColor="#0ABB87"
                        text={data["cash_status"]}
                      />
                    </TableBodyCell>
                  </TableBody> */}

                  {/* <TableBody>
                    <TableBodyCell>Collecter Id</TableBodyCell>
                    <TableBodyCell>{data["collector_id"]}</TableBodyCell>
                  </TableBody> */}
                  <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">Comment</TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      {data["comment"]}
                    </TableBodyCell>
                    </TableRow>
                  </TableBody>
                  <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">Created Date</TableBodyCell>
                    <TableBodyCell className="common_table_content">
                      {readableFormatDate(data["deposit"]["created_at"])}
                    </TableBodyCell>
                    </TableRow>
                  </TableBody>
                </table>
              </Grid>
            </CustomTableWrapper>
          </CardContent>
        </Card>
      ) : null}
    </>
  );
};
